var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.999,
    height: 51.334,
    viewBox: "0 0 76.999 51.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:#bfbfbf}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_411",
    "data-name": "Group 411",
    transform: "translate(-922 -495.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_410",
    "data-name": "Group 410",
    transform: "translate(922 495.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_76",
    d: "M15177.4-7140.2h13.9l17.475 35.1h-7.877l-13.9-28.225h-6.445z",
    className: "prefix__cls-1",
    "data-name": "Path 76",
    transform: "translate(-15177.401 7140.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_77",
    d: "M15207.2-7140.2h56.875l-17.617 34.817h-21.773l-3.3-6.509h19.473l12.338-21.719h-34.824l13.475 28.228h-7.164z",
    className: "prefix__cls-1",
    "data-name": "Path 77",
    transform: "translate(-15187.075 7140.202)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_46",
    cx: 5.661,
    cy: 5.661,
    r: 5.661,
    className: "prefix__cls-1",
    "data-name": "Ellipse 46",
    transform: "translate(21.34 40.011)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_47",
    cx: 5.661,
    cy: 5.661,
    r: 5.661,
    className: "prefix__cls-1",
    "data-name": "Ellipse 47",
    transform: "translate(50.239 40.011)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_157",
    d: "M4.189-4.5H1.523L1.1-14.219h3.509zM1.006-1.475a1.516 1.516 0 0 1 .522-1.187 1.892 1.892 0 0 1 1.3-.464 1.892 1.892 0 0 1 1.3.464 1.516 1.516 0 0 1 .522 1.187 1.516 1.516 0 0 1-.514 1.187 1.892 1.892 0 0 1-1.3.464 1.892 1.892 0 0 1-1.3-.464 1.516 1.516 0 0 1-.53-1.187z",
    className: "prefix__cls-1",
    "data-name": "Path 157",
    transform: "translate(967 520)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmpty);
export default __webpack_public_path__ + "static/media/cart-empty.954eff4e478ef2d64e57098cc6820e2c.svg";
export { ForwardRef as ReactComponent };